import { IconButton, Menu } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import { UploadMenuItem } from './uploadDialog/UploadMenuItem';

export const DataMeteringMenu: React.FC = () => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <VyIcon icon="DotsMenu"/>
      </IconButton>

      <Menu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        slotProps={{ paper: { className: 'max-w-[225px] w-full' } }}
      >
        <UploadMenuItem/>
      </Menu>
    </>
  );
};